import React, { useEffect, useState } from "react";
import { SlovHeader } from "./KCATSNIGHT_slovHeaderTuring";

export const KCatsTuringFinalVoteScreen = (props) => {
    const [voted, setVoted] = useState(false);

    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    const vote = (answer) => {
        if (voted) return;

        setVoted(true);
        props.sendMessage(`sendtoserver|slov\\buttonchosen\\kcatsuring_vote\\${answer}`);
    };

    return (
        <div id="game">
            <SlovHeader />

            <div style={{ margin: "28px auto", width: "90%", maxWidth: "600px", textAlign: "center" }}>
                <div className="divtext_slov"><b>Тест Кикецюринга</b></div>
                <br />
                <div style={{ fontSize: "22px", fontWeight: "bold", color: "#111" }}>
                    Был ли ваш собеседник KCats?
                </div>
                <div style={{ marginTop: "10px", fontSize: "14px", color: "#666" }}>
                    За правильный ответ вы получите 60 очков.
                </div>

                {!voted ? (
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "14px",
                            marginTop: "26px",
                        }}
                    >
                        <button
                            type="button"
                            onClick={() => vote("yes")}
                            style={{ minHeight: "70px", fontSize: "22px" }}
                        >
                            Да
                        </button>

                        <button
                            type="button"
                            onClick={() => vote("no")}
                            style={{ minHeight: "70px", fontSize: "22px" }}
                        >
                            Нет
                        </button>
                    </div>
                ) : (
                    <div style={{ marginTop: "28px", fontSize: "18px", color: "#444" }}>
                        Ответ отправлен. Ожидайте остальных игроков...
                    </div>
                )}
            </div>
        </div>
    );
};
